import { ControlButton } from '@xyflow/react';
import { Maximize2, Minimize2 } from 'lucide-react';
import type { ObservabilityViewMode } from './types';

export interface ArchitectureViewModeToggleProps {
  mode: ObservabilityViewMode;
  onToggle: () => void;
}

export function ArchitectureViewModeToggle({ mode, onToggle }: ArchitectureViewModeToggleProps) {
  const isFullscreen = mode === 'fullscreen';
  const label = isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen';

  return (
    <ControlButton onClick={onToggle} aria-label={label} title={label}>
      {isFullscreen ? (
        <Minimize2 className="size-4" aria-hidden />
      ) : (
        <Maximize2 className="size-4" aria-hidden />
      )}
    </ControlButton>
  );
}
